import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { PageTitleModuleGeneric } from '@signature-it/ngx-generic/components/page';
import { CmsModule } from '@signature-it/ngx-generic/components/cms';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { BreadcrumbsModule } from '@signature-it/ngx-generic/components/breadcrumbs';
import { MainHeaderModuleGeneric } from '@signature-it/ngx-generic/components/header';
import { MainFooterModuleGeneric, MainFooterComponent } from '@signature-it/ngx-generic/components/footer';
import { MainLayoutComponentGeneric } from './main';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        CmsModule,
        ContentloaderModule,
        MatSidenavModule,
        BreadcrumbsModule,
        PageTitleModuleGeneric,
        MainHeaderModuleGeneric,
        MainFooterModuleGeneric
    ],
    exports: [MainLayoutComponentGeneric],
    declarations: [MainLayoutComponentGeneric]
})
export class MainLayoutModuleGeneric {}

@NgModule({
    imports: [
        MainLayoutModuleGeneric,
        // MainRoutingModuleGeneric
    ]
})
export class MainLayoutModuleGeneric_Wrapper {}
